import { render, staticRenderFns } from "./SmallerWithSearchAndButton.vue?vue&type=template&id=1a57da34&"
import script from "./SmallerWithSearchAndButton.vue?vue&type=script&lang=js&"
export * from "./SmallerWithSearchAndButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports